<template>
  <InParens
    :visible="outerParens"
    baseClass="cond-view-paren"
    hoverClass="cond-view-paren cond-view-paren-hover"
  >
    <template v-if="isCondNot(condition)">
      <div class="logic pr-0.5">not</div>

      <ConditionView :condition="condition.Not" :parentLogic="condType" />
    </template>

    <template v-else-if="isCondAnd(condition) || isCondOr(condition)">
      <ConditionView
        v-if="inner.length > 0"
        :condition="inner[0]"
        :parentLogic="condType"
      />

      <template v-if="inner.length > 1">
        <div class="logic px-0.5">
          {{ isCondAnd(condition) ? "and" : "or" }}
        </div>

        <ConditionView
          v-if="inner.length > 1"
          :condition="cutils.wrap(condition, inner.slice(1))"
          :parentLogic="condType"
        />
      </template>
    </template>

    <template v-else>{{ assertUnreachable(condition) }}</template>
  </InParens>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { assertUnreachable } from "@/utils";
import {
  isCondNot,
  isCondAnd,
  isCondOr,
  ConditionLogic,
  ConditionTypeLogic,
  conditionTypeLogic,
} from "@/keyboard/leds";
import * as cutils from "@/keyboard/condition_utils";
import ConditionView from "@/components/leds/ConditionView.vue";
import InParens from "@/components/leds/InParens.vue";

const props = defineProps<{
  condition: ConditionLogic;
  parentLogic?: ConditionTypeLogic;
}>();

const cond = computed(() => props.condition);
const inner = computed(() => cutils.inner(cond.value));
const condType = computed(() => conditionTypeLogic(cond.value));
const outerParens = computed(() =>
  cutils.outerParens(condType.value, props.parentLogic)
);
</script>

<style>
.cond-view-paren {
  @apply font-mono;
}
.cond-view-paren-hover {
  @apply font-semibold underline underline-offset-4;
}
</style>

<style scoped>
.logic {
  @apply font-mono uppercase text-sm;
}
</style>
